import { Component, Input, OnInit, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { CookieService } from 'ngx-cookie-service';
import { Location } from '@angular/common';

import { Marker, Map, LngLatLike, Popup } from 'mapbox-gl';
import * as Mapboxgl from 'mapbox-gl';

import { environment } from '../../../../environments/environment.prod';

import { Prop } from '../../interfaces/prop.interface';
import { propExtended } from '../../interfaces/propExtended.interface';

import { PropertyService } from '../../services/property.service';
import { FormBuilder, ReactiveFormsModule, FormGroup, Validators, FormControl } from '@angular/forms';
import { NgForm } from '@angular/forms';
import { ReCaptchaV3Service } from 'ng-recaptcha';

@Component({
  selector: 'app-propertydetail',
  templateUrl: './propertydetail.component.html',
  styleUrls: ['./propertydetail.component.css']
})
export class PropertydetailComponent implements OnInit, AfterViewInit {


  isSearch4: string = ''; // 1 Venta / 2 Alquiler / 3 Alquiler con opción a venta
  use: string = '';
  province: string = '';
  city: string = '';
  district: string = '';
  id: string = '';
  uuid: string = '';

  supObj: any;
  smoke: any;

  generatedName: any;
  cityName: string = '';
  districtNamne: string = '';
  provinceName: string = '';
  useName: string = '';
  generatedComment: string = '';

  urlVideo: string = '';
  urlVideoSafe: any;

  prop: Prop | undefined;
  propExtend: propExtended[] | undefined;

  showMore: boolean = false;
  showMoreText: string = 'Mostrar más';

  formVisible: boolean = true;
  formResponse: string = "";
  captchaToken: string = "";

  fakeName: string = '';
  fakeDesc: string = '';

  privacyActive: boolean = false;
  consentActive: boolean = false;

  privacy_tip = false;

  loaded: boolean = false;

  detailMap!: Map;

  contactForm: FormGroup = new FormGroup({
    name: new FormControl({ value: '', disabled: false }, [Validators.required]),
    phone: new FormControl({ value: '', disabled: false }, [Validators.required, Validators.pattern(/^([0-9])*$/), Validators.minLength(7), Validators.maxLength(10)]),
    email: new FormControl({ value: '', disabled: false }, [Validators.required, Validators.email]),
    message: new FormControl({ value: 'Estoy interesado en este inmueble', disabled: false }, [Validators.required]),
    privacy: new FormControl({ value: false, disabled: false }, [Validators.requiredTrue]),
    consent: new FormControl({ value: false, disabled: false }),
  })

  constructor(
    private router: Router,
    private activeRoute: ActivatedRoute,
    private propertyService: PropertyService,
    public sanitizer: DomSanitizer,
    private fb: FormBuilder,
    private recaptchaV3Service: ReCaptchaV3Service,
    private cookieService: CookieService,
    private location: Location
  ) {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false; // Can reload the page
    this.activeRoute.queryParams.subscribe(params => {
      this.isSearch4 = params['isSearch4'];
      this.use = params['use'];
      this.province = params['province']
      this.city = params['city']
      this.uuid = params['uuid']
      this.district = params['district']
      this.generatedName = params['generatedName']
      this.cityName = params['cityName']
      this.districtNamne = params['districtNamne']
      this.provinceName = params['provinceName']
      this.useName = params['useName']
      this.supObj = params['supObj']
      this.smoke = params['smoke'],
        this.generatedComment = params['generatedComment']
    });
    this.id = this.activeRoute.snapshot.params['id'];

    let reqUrl = {
      isSearch4: this.isSearch4,
      use: this.use,
      province: this.province,
      city: this.city,
      district: this.district
    };
    this.cookieService.set('reqUrl', JSON.stringify(reqUrl), 1, '/');

    (Mapboxgl as any).accessToken = environment.mapboxToken;
  }

  ngOnInit(): void {
    this.detailMap = new Map({
      container: 'detailMap',
      style: 'mapbox://styles/mapbox/streets-v11',
      center: [-3.74922, 40.463667], // [lng, lat]
      zoom: 5
    });

    this.propertyService.getPropertyById(this.uuid).subscribe({
      next: (resp) => {
        this.prop = resp
        this.propExtend = resp
        if (this.prop) {
          this.propertyService.getImagesById(this.prop.id!).subscribe({
            next: (resp) => {
              this.prop!.images = resp.rows;
              // console.log(this.prop!.images)
            },
            error: (err) => { }
          })

          this.fakeName = this.generatedName
          let useName = this.useName

          if (this.prop.use == "0") {
            useName = "Activo"
          }
          if (useName === "Vivienda") {
            this.fakeDesc = useName + " ubicada en " + this.prop.address + ", dentro del Municipio de " + this.cityName + ", en la Provincia de " + this.provinceName + ".<br/>Cuenta con una superficie total de <b>" + this.prop.surfaceTotal + "</b> m<sup>2</sup>";
          } else {
            this.fakeDesc = useName + " ubicado en " + this.prop.address + ", dentro del Municipio de " + this.cityName + ", en la Provincia de " + this.provinceName + ".<br/>Cuenta con una superficie total de <b>" + this.prop.surfaceTotal + "</b> m<sup>2</sup>";
          }

          // Obtenemos las superficies que son mayores a 0
          const surfaces = [
            { label: "planta calle", value: Number(this.prop.surfacepb) },
            { label: "planta sótano", value: Number(this.prop.surfacebr) },
            { label: "planta entresuelo", value: Number(this.prop.surfaceMezzanine) },
            { label: "planta 1", value: Number(this.prop.surfaceBasement1) },
            { label: "planta 2", value: Number(this.prop.surfaceBasement2) }
          ].filter(surface => surface.value > 0);

          // Verificamos si hay más de una superficie

          if (surfaces.length > 1) {
            this.fakeDesc += ", distribuídos en ";
            surfaces.forEach((surface, index) => {
              if (index === surfaces.length - 1 && index !== 0) {
                this.fakeDesc += " y ";
              }
              this.fakeDesc += `<b>${surface.value}</b> m<sup>2</sup> en ${surface.label}`;
              if (index < surfaces.length - 2) {
                this.fakeDesc += ", ";
              }
            });
          } else if (surfaces.length === 1) {
            // Si solo hay una superficie, la añadimos sin "distribuídos en"
            this.fakeDesc += `, con <b>${surfaces[0].value}</b> m<sup>2</sup> en ${surfaces[0].label}.`;
          } else {
            // Si no hay superficies, simplemente cerramos la descripción
            this.fakeDesc += ".";
          }

          if (this.prop.video) {
            this.urlVideo = this.prop.video + "?autoplay=0&loop=1&byline=0&title=0&output=embed&controls=1";
            this.urlVideoSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.urlVideo);
          }

          this.detailMap.easeTo({
            center: [this.prop.lng!, this.prop.lat!],
            zoom: 12
          })
          const newMarker = new Marker({ color: '#ee7502', offset: [0, -20] })
            .setLngLat([this.prop.lng!, this.prop.lat!])
            .addTo(this.detailMap);
        }

        this.loaded = true;

      },
      error: (err) => {
        console.log(err);
      }

    })

  }

  ngAfterViewInit(): void {
    if (this.prop) {
      this.detailMap.easeTo({
        center: [this.prop.lng!, this.prop.lat!],
        zoom: 12
      })
      const newMarker = new Marker({ color: '#ee7502', offset: [0, -20] })
        .setLngLat([this.prop.lng!, this.prop.lat!])
        .addTo(this.detailMap);
    }
  }

  privacyAlert() {
    if (!this.privacyActive && this.contactForm.valid) {
      this.privacy_tip = true;
    }
  }

  privacyAlertExit() {
    if (!this.privacyActive && this.contactForm.valid) {
      this.privacy_tip = false;
    }
  }

  privacy() {
    this.privacyActive = true;
    window.open('/proteccion-datos', "_blank");
  }
  consent() {
    this.privacyActive = true;
  }
  sendContact() {
    this.formVisible = false;
    this.recaptchaV3Service.execute('importantAction')
      .subscribe((token: string) => {
        this.captchaToken = token;
        const data = {
          name: this.contactForm.value.name,
          email: this.contactForm.value.email,
          phone: this.contactForm.value.phone,
          message: this.contactForm.value.message,
          privacy: this.contactForm.value.privacy,
          consent: this.contactForm.value.consent,
          id_ext: this.prop?.id_ext,
          cityName: this.cityName,
          provinceName: this.provinceName,
          address: this.prop?.address,
          action: 'contact_form',
          g_recaptcha_token: this.captchaToken
        }
        this.propertyService.contactForm(data).subscribe({
          next: (resp) => {
            this.formResponse = "<p>Gracias por contactar con nosotros. Nos pondremos en contacto contigo lo antes posible.</p>"
            this.captchaToken = "";
          },
          error: (err) => {
            console.log(err);
            this.formResponse = "<p>Se ha producido un error. Por favor, vuelve a intentarlo.</p>"
          }
        })
      });

    this.formResponse = "<p>Gracias por contactar con nosotros. Nos pondremos en contacto contigo lo antes posible.</p>"

  }

  generateName() {
    let generatedName = this.generatedName
    // generatedName = this.propExtend![0].useName + ' en ' + this.propExtend![0].address + ', ' + this.propExtend![0].cityName + ', ' + this.propExtend![0].provinceName
    return generatedName
  }

  toggleShowMore() {
    if (this.showMore) {
      this.showMore = false;
      this.showMoreText = 'Mostrar más';
    } else {
      this.showMore = true;
      this.showMoreText = 'Mostrar menos';
    }
  }

  gotBackToPropertiesMain() {
    this.detailMap.remove();
    this.router.navigate(['/inmueblesmain'],
      {
        queryParams: {
          isSearch4: this.isSearch4,
          use: this.use,
          province: this.province,
          city: this.city,
          district: this.district,
          smoke: this.smoke,
          supObj: this.supObj
        }
      }
    );

  }

}
